import { useQuery } from "react-query";
import { getData } from "../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";

// export interface ProviderAccount {
//   id: number;
//   accountName: string;
//   accountNumber: string;
//   bankCode: string;
//   bankName: string;
//   bvn: string | null;
//   providerId: number;
//   isSetProviderAccount: boolean;
//   isDisabled: boolean;
// }

// export interface ProviderList {
//   id: number;
//   name: string;
//   maximumTransferAmount: number;
//   isCurrentOutwardTransferProvider: boolean;
//   isCurrentNameEnquiryProvider: boolean;
//   currentProviderAccountId: number | null;
//   thresholdAmount: number;
//   accounts: ProviderAccount[];
// }

// export interface ProvidersResponse {
//   data: {
//     providers: ProviderList[];
//     currentNameEnquiryProviderId: number;
//     currentFundsTransferProviderId: number;
//   };
// }

// export type Bank = {
//   bankCode: string;
//   bankName: string;
//   pngLogoUrl: string | null;
//   svgLogoUrl: string | null;
// };

const fetchPaperMandateTemplate = async () => {
  const response = await getData(ajaxEndpoints.GET_PAPER_MANDATE_TEMPLATE);
  return response?.data;
};

export const useFetchPaperMandateTemplate = () => {
  return useQuery("fetchPaperMandateTemplate", () =>
    fetchPaperMandateTemplate(),
  );
};

const fetchNibssMandateTypes = async () => {
  const response = await getData(ajaxEndpoints.FETCH_NIBSS_MANDATE_TYPES);
  return response?.data;
};

export const useFetchNibssMandateTypes = () => {
  return useQuery("fetchNibssMandateTypes", () => fetchNibssMandateTypes());
};
